import StyleGuideDataTableVM from './table-vm';
export default {
  init: function() {
    console.log('Kadenze.CommonStyleGuideKdDataTable initialization function called');

    ko.applyBindings(new StyleGuideDataTableVM(), document.getElementById('data_table'));
  }
};

